export default __webpack_public_path__ + "static/media/ukraine.f93926fb.png";